<template>
    <!-- 值班人员列表确认弹窗 -->
    <veui-confirm-box
        :open="confirm"
        @ok="ok"
        @cancel="cancel"
    >
        <div class="dutu-staff-box">
            <div class="dutu-staff-box-menu">
                <span class="dutu-staff-box-menu-label">选择宿主</span>
                <!-- veui-radio-group选中时会自动为body添加上overflow:visible的属性，利用change事件强制禁止 -->
                <veui-radio-group
                    v-model="selectedFollowId"
                    :items="followUserList"
                    class="dutu-staff-box-menu-options"
                    @change="notAllowScroll"
                />
            </div>
            <div class="dutu-staff-box-selected">
                <span>确认选择该人员：</span>
                <span>{{selectedFollowName}}</span>
            </div>
        </div>
    </veui-confirm-box>
</template>


<style lang="less">
    @import '../../assets/less/views/follow-user-box.less';

    .veui-dialog-content {
        overflow: visible;
    }
</style>

<script>
import {ConfirmBox, RadioGroup} from 'veui';
import {throttle} from '@/utils/debounceThrottle';
import toast from '@/utils/decorate/toast';
import {notAllowScroll} from '@/utils/decorate/scroll';

export default {
    props: {
        confirm: {
            'type': Boolean,
            'default': false
        },
        selected: {
            'type': Number,
            'default': -1
        },
        allownouser: {
            'type': Boolean,
            'default': false
        },
        listtype: {
            'type': String,
            'default': 'officialsupporter'
        }
    },
    components: {
        'veui-confirm-box': ConfirmBox,
        'veui-radio-group': RadioGroup
    },
    beforeMount() {
        switch (this.listtype) {
            case 'officialsupporter': this.$store.dispatch('getOfficialFollowerList')
                .then(data => this.storeFollowUserList(data));
                break;
            case 'officialauthor': this.$store.dispatch('getOfficialAuthorList')
                .then(data => {
                    this.storeFollowUserList(data);
                });
                break;
        }
    },
    data() {
        return {
            noFollowerInfo: {
                value: 0,
                label: '无'
            },
            followUserList: [],
            selectedFollowId: this.selected
        };
    },
    computed: {
        selectedFollowName: {
            get() {
                for (let item of this.followUserList) {
                    if (this.selectedFollowId === item.value) {
                        return item.label;
                    }
                }
                return '';
            }
        }
    },
    methods: {
        notAllowScroll,
        ok: throttle(function () {
            if (this.selectedFollowId === -1) {
                toast.info('您尚未选择跟进人员，请重新选择');
                this.cancel();
                return;
            }
            for (let item of this.followUserList) {
                if (this.selectedFollowId === item.value) {
                    let selectedFollowInfo = {
                        id: item.value,
                        nickname: item.label,
                        avatar: item.img
                    };
                    this.$emit('ok', selectedFollowInfo);
                }
            }
            this.cancel();
        }),
        cancel() {
            this.$emit('cancel');
        },
        storeFollowUserList(userList) {
            this.followUserList = userList.map(item => {
                return {
                    value: item.id,
                    label: item.nickname,
                    img: item.avatar
                };
            });
            if (this.allownouser) {
                this.followUserList.unshift(this.noFollowerInfo);
            }
        }
    }
};
</script>
